import { Button, Tooltip } from 'antd';
import React, { ReactNode, useCallback } from 'react';
import { CgTrash } from 'react-icons/cg';
import { FaArrowDown, FaArrowUp, FaEdit, FaPlus } from 'react-icons/fa';
import './editComponent.less';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteModuleFromPage,
  deleteModuleFromConfigs,
  updateModuleIndex,
} from '../store/config';
import { RootState } from '../store/store';
import {ModuleErrorBoundary} from '../components/ErrorBoundary/ModuleErrorBoundary';
import { setPageConfig } from '../store/dynamicPageConfigSlice';
import { removeModuleFromModulesArray, reorderModulesArray } from '@skygroup/shared/utils/modulesConversion';

interface Props {
  pageId: string;
  pagePath: string;
  pageComponents: string[];
  children: ReactNode;
  instance: string;
  index: string;
  setComponents?: any;
  allowOnlyEdit?: boolean;
  selectedInstance: string | null;
  setSelectedInstance: React.Dispatch<React.SetStateAction<string | null>>;
  moduleName: string;
  isEditAllowed?: boolean;
  isDynamicPage?: boolean;
}

const EditComponent = ({
  pageId,
  pagePath,
  pageComponents,
  children,
  instance,
  index,
  setComponents,
  allowOnlyEdit = false,
  selectedInstance,
  setSelectedInstance,
  moduleName,
  isEditAllowed,
  isDynamicPage = false,
}: Props) => { 
  const {
    config: { modulesConfigs },
    translations,
  } = useSelector((data: RootState) => data.config);

  // const displayInline = ["FlightList", "PackageListView", "AttractionListView"].includes(moduleName);
  const moduleConfig = modulesConfigs[instance || moduleName];
  const brokenModule = !moduleName;
  const dynamicPageConfig = useSelector((state: RootState) => state.dynamicPageConfig);

    const displayInline = isDynamicPage ?
        (dynamicPageConfig?.dynamicPageConfig?.modules?.[instance || moduleName]?.set === 'FlightListSet2' ||
            dynamicPageConfig?.dynamicPageConfig?.modules?.[instance || moduleName]?.set === 'PackageListViewSet3' ||
            dynamicPageConfig?.dynamicPageConfig?.modules?.[instance || moduleName]?.module === 'AttractionListView') :
        (moduleConfig?.set === 'FlightListSet2' ||
            moduleConfig?.set === 'PackageListViewSet3' ||
            moduleName === 'AttractionListView');


    // const INLINE_SETS = ['FlightListSet2', 'PackageListViewSet3'];
    // const INLINE_MODULES = ['AttractionListView'];
    //
    // const getModule = () => {
    //   if (isDynamicPage) {
    //     return dynamicPageConfig?.dynamicPageConfig?.modules?.[instance || moduleName];
    //   }
    //   return moduleConfig;
    // };
    //
    // const currentModule = getModule();
    //
    // const displayInline =
    //     INLINE_SETS.includes(currentModule?.set ?? '') ||
    //     INLINE_MODULES.includes(currentModule?.module ?? '') ||
    //     (!isDynamicPage && INLINE_MODULES.includes(moduleName ?? ''));
    //

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isEditMode = searchParams.get('editMode') === 'true' && isEditAllowed;

  const handleEditOpen = (data: {
    instance: string;
    pageId: string;
    moduleName: string;
    index: string;
  }) => {
    setSelectedInstance(data.instance);
    window.parent.postMessage(
      {
        type: 'EditModule',
        message: data,
      },
      '*'
    );
  };

const moveModule = (data: {
  dragIndex: any;
  hoverIndex: any;
  pageId: string;
  pagePath: string;
}) => {
  // Validate indices using pageComponents, consistent for both dynamic and non-dynamic cases
  // if (data.dragIndex < 0 || data.hoverIndex > pageComponents.length - 1) {
  //   return;
  // }
  // determine authoritative length
  const modulesLen = isDynamicPage
    ? (dynamicPageConfig?.dynamicPageConfig?.pageConfig?.modules?.length ?? 0)
    : (pageComponents?.length ?? 0);

  if (modulesLen === 0) return;

  if (
    data.dragIndex < 0 ||
    data.dragIndex >= modulesLen ||
    data.hoverIndex < 0 ||
    data.hoverIndex >= modulesLen
  ) {
    return;
  }
  // Send message to parent window (common to both cases)


if (isDynamicPage) {
  const currentConfig = dynamicPageConfig.dynamicPageConfig;
  if (!currentConfig || !currentConfig.pageConfig) {
    console.error('Invalid dynamicPageConfig');
    return;
  }

  const modulesArray = currentConfig.pageConfig.modules || [];
  const updatedModulesArray = reorderModulesArray(modulesArray, data.dragIndex, data.hoverIndex);

  const updatedPageConfig = {
    ...currentConfig.pageConfig,
    modules: updatedModulesArray,
  };

  const updatedDynamicPageConfig = {
    ...currentConfig,
    pageConfig: updatedPageConfig,
  };

  dispatch(setPageConfig({ dynamicPageConfig: updatedDynamicPageConfig }));

  window.parent.postMessage(
    {
      type: 'UpdateWhiteLabelModulesIndexes',
      ...data,
      isDynamicPage: isDynamicPage,
      dynamicPageConfig: updatedDynamicPageConfig,
    },
    '*'
  );
} else {
      dispatch(updateModuleIndex(data));
      window.parent.postMessage(
      {
        type: 'UpdateWhiteLabelModulesIndexes',
        ...data,
        isDynamicPage: isDynamicPage,
      },
      '*'
    );
  }
};


  const handleDelete = (data: {
    instance: string;
    moduleName: string;
    pageId: string;
    pagePath: string;
  }) => {


    if (isDynamicPage) {
      // Create a copy of dynamicPageConfig to avoid mutating state
      const updatedDynamicPageConfig = {...dynamicPageConfig.dynamicPageConfig};

      // Remove the module from dynamicPageConfig.modules
      const {[data.instance]: _, ...updatedModules} = updatedDynamicPageConfig.modules || {};
      updatedDynamicPageConfig.modules = updatedModules;

      // Update pageConfig.modules by removing the instance
      const updatedPageConfig = {
        ...updatedDynamicPageConfig.pageConfig,
        modules: removeModuleFromModulesArray(updatedDynamicPageConfig.pageConfig?.modules, data.instance),
      };
      updatedDynamicPageConfig.pageConfig = updatedPageConfig;
      console.log(updatedDynamicPageConfig, "updatedDynamicPageConfig")
      // Dispatch the updated dynamicPageConfig to Redux
      dispatch(setPageConfig({dynamicPageConfig: updatedDynamicPageConfig}));
      window.parent.postMessage(
          {
            type: 'DeleteWhiteLabelModulesFromPage',
            ...data,
            isDynamicPage: isDynamicPage,
            dynamicPageConfig: updatedDynamicPageConfig || null,
          },
          '*'
      );
    } else {
      dispatch(deleteModuleFromPage(data));
      window.parent.postMessage(
          {
            type: 'DeleteWhiteLabelModulesFromPage',
            ...data,
            isDynamicPage: isDynamicPage
          },
          '*'
      );
    }
  };

  const handleAddModule = ({ i }: { i: number }) => {
    window.parent.postMessage(
      { type: 'AddModule', message: { index: i } },
      '*'
    );
  };

  const getEditModeClassName = () => {
    let name = ``;
    if (isEditMode) {
      name += ' ' + 'EDIT';
    }
    if (allowOnlyEdit) {
      name += ' ' + 'ONLY-EDIT';
    }
    if (selectedInstance === instance) {
      name += ' ' + 'EDIT-MODE-ON';
    }
    if (displayInline) {
      name += ' ' + 'INLINE-MODULES-GROUP-ITEM';
    }

    return name || undefined;
  };


  return (
    <div id={`${moduleName}-wrapper`} className={getEditModeClassName()}>
      {isEditMode && (
        <div className="EDIT-BUTTON">
          {!allowOnlyEdit && (
            <Button
              className="add-btn-top"
              icon={<FaPlus />}
              onClick={() => handleAddModule({ i: Number(index) })}
            >
              Add Module on Top
            </Button>
          )}

          <div className="edit-actions-wrapper">
            {!allowOnlyEdit && (
              <div className="arrows-wrapper">
                <FaArrowUp
                  className={`button ${Number(index) <= 0 ? 'disabled' : ''}`}
                  size={18}
                  onClick={() =>
                    moveModule({
                      pageId,
                      pagePath,
                      dragIndex: Number(index) - 1,
                      hoverIndex: Number(index),
                    })
                  }
                />
                <FaArrowDown
                  className={`button ${
                    Number(index) + 1 >= pageComponents.length ? 'disabled' : ''
                  }`}
                  size={18}
                  onClick={() =>
                    moveModule({
                      pageId,
                      pagePath,
                      dragIndex: Number(index),
                      hoverIndex: Number(index) + 1,
                    })
                  }
                />
              </div>
            )}

            {moduleName && (
              <div
                onClick={() => {
                  handleEditOpen({ instance, pageId, moduleName, index });
                }}
                className="edit"
              >
                <FaEdit size={18} className="button" />
              </div>
            )}

            {(!allowOnlyEdit || brokenModule) && (
              <div
                className="delete"
                onClick={() => {
                  handleDelete({ instance, pageId, moduleName, pagePath });
                }}
              >
                <CgTrash size={18} className="button" />
              </div>
            )}
          </div>

          {!allowOnlyEdit && (
            <Button
              className="add-btn-bottom"
              icon={<FaPlus />}
              onClick={() => handleAddModule({ i: Number(index) + 1 })}
            >
              Add Module on Bottom
            </Button>
          )}
        </div>
      )}
      <ModuleErrorBoundary t={translations}>
        {children}
      </ModuleErrorBoundary>
    </div>
  );
};

export default EditComponent;
